/* eslint max-len: 0 */
const icon = require('vue-svgicon')
icon.register({
  'link': {
    viewBox: '0 0 32 32',
    data: `<g><path d="M21,2c-0.6,0-1,0.4-1,1s0.4,1,1,1h5.6l-9.3,9.3c-0.4,0.4-0.4,1,0,1.4c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3L28,5.4V11c0,0.6,0.4,1,1,1s1-0.4,1-1V2H21z"/><path d="M26,15c-0.6,0-1,0.4-1,1v9H7V7h9c0.6,0,1-0.4,1-1s-0.4-1-1-1H5v22h22V16C27,15.4,26.6,15,26,15z"/></g>`
  }
})
